import React from "react";
import styles from "./PrivacyPolicyDescription.module.css";
import RichText from "../RichText/RichText";
const PrivacyPolicyDescription = ({ data }: any) => {
  return (
    <div className="container">
      <div className={styles.privacyPolicyDescription}>
        <RichText data={data} />
      </div>
    </div>
  );
};

export default PrivacyPolicyDescription;
